export enum STOItemStatusEnum {
  QUEUE = 'item-queue',
  PICKING = 'item-picking',
  CHECKING = 'item-checking',
  CHECKED = 'item-checked',
  RECEIVING = 'item-receiving',
  RECEIVE_UPDATING = 'item-receive-updating',
  RECEIVE_UPDATE_FAILED = 'item-receive-update-failed',
  RECEIVED = 'item-received',
}
